import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Tree = _resolveComponent("Tree")

  return (_openBlock(), _createBlock(_component_Tree, {
    value: $options.nodes,
    unstyled: false,
    class: "json-viewer"
  }, {
    default: _withCtx((props) => [
      _createElementVNode("b", null, _toDisplayString(props.node.label), 1 /* TEXT */),
      _cache[0] || (_cache[0] = _createTextVNode(": ")),
      _createElementVNode("span", {
        class: _normalizeClass(["value", {
              str: props.node.is_str,
              date: props.node.is_date,
              num: props.node.is_num,
              bool: props.node.is_bool,
              null: props.node.is_null
            }])
      }, _toDisplayString(props.node.data), 3 /* TEXT, CLASS */)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["value"]))
}